<template>
  <div class="smy__card-full-box">
      <div class="top">
        <div class="topLeft">
          订单数：{{invoiceListDetail.order_num}}
        </div>
        <div class="topright">
          发票总金额：{{invoiceListDetail.order_total_amount}}
        </div>
      </div>
      <div class="table" style="margin:17px 0">
          <Table
            stripe
            ref="table"
            :loading="loading"
            :columns="columns"
            :data="list"
          />
      </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  props: {
    invoiceListDetail: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      list: [],
      loading: false
    }
  },
  computed: {
    ...mapState('table', [
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作',
          width: 140,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let check = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'IssueInvoiceDetailOrderDetail', params: { orderId: row.id } })
                }
              }
            }, ['查看订单'])
            return h('span', [check])
          }
        },
        {
          title: '订单号',
          key: 'order_no',
          width: 200
        },
        {
          title: '代理付款金额',
          key: 'agent_pay_price',
          width: 140
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  methods: {
  },
  created () {
    setTimeout(() => {
      this.list = this.invoiceListDetail.orders
    }, 200)
  }
}
</script>

<style lang="less" scoped>
.top{
  display: flex;
  .topLeft{
    width: 200px;
  }
  .topRight{
    width: 100%
  }
}
.accountRemant{
  display: flex;
  .left{
    width: 300px;
    flex-shrink: 0;
  }
  .right{
    width: 100%;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/handle/isuseInvoiceHandle/InvoiceDetailRight.vue